import db from 'database';
import Helpers, { findEarliestAvailableID } from 'shared/helpers';
import moment from 'moment';

export default class Impacto {
  _id;
  fase;
  user;
  etec;
  pem;
  produtividade;
  classificacao;
  porcentagem;
  preco;
  createdAt;
  updatedAt;
  deletedAt;

  /**
   *
   * @param {Object} data
   * @param {Number} data.id
   * @param {Number} data.fase
   * @param {Number} data.user
   * @param {Number} data.etec
   * @param {Number} data.pem
   * @param {any} data.produtividade
   * @param {any} data.classificacao
   * @param {any} data.porcentagem
   * @param {any} data.preco
   * @param {String} [data.createdAt]
   * @param {String} [data.updatedAt]
   * @param {String} [data.deletedAt]
   */
  constructor(data) {
    Helpers.constructModel(data, this);
  }

  async save() {
    const curb = await db.impactos.filter(
      x =>
        String(x.id) === String(this.id) ||
        String(x.pem_id) === String(this.pem),
    );
    await curb.delete();
    this.updatedAt = moment()
      .toDate()
      .toISOString();
    this._id = await findEarliestAvailableID(db, 'impactos');
    return db.impactos.put(this);
  }

  static describe = () =>
    '++_id, fase, user, pem, produtividade, classificacao, porcentagem, preco, createdAt, updatedAt, deletedAt';
}
